import { render, staticRenderFns } from "./tableCompontent.vue?vue&type=template&id=29452a79&scoped=true"
import script from "./tableCompontent.vue?vue&type=script&lang=js"
export * from "./tableCompontent.vue?vue&type=script&lang=js"
import style0 from "./tableCompontent.vue?vue&type=style&index=0&id=29452a79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29452a79",
  null
  
)

export default component.exports